import { breakpoints } from '@r1-frontend/entities/Layout/Header/types';

import { DocumentText } from '@r1-frontend/ui-kit/atoms/svg/content';
import { Text } from '@r1-frontend/ui-kit/atoms/typography/text';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { MenuButton } from './MenuButton';

export const AgreementButton = () => {
    const isSmallMobile = useMatchMediaByWidth(breakpoints.mMobile);

    return (
        <MenuButton>
            <DocumentText size={isSmallMobile ? 24 : 20}/>
            {!isSmallMobile && (
                <Text $color={'head'} $size={'md'} $weight={'medium'}>Договор</Text>
            )}
        </MenuButton>
    );
};
